import { getMarkJS, SPAN_ELEMENT_NAME, UNMARK_ELEMENT_LABEL } from './constants';
import createMarkId from './createMarkId';

export type EachElementCallback = (
    keyword: string
) => (element: HTMLElement, instance?: number) => void;
export type Accuracy = 'partially' | 'prefix';

// used to bypass loading markjs if no
// search terms are ever passed in
let hasEverMarked = false;

export default async function markElements(
    element: HTMLElement,
    keywords: string[],
    eachCallback: EachElementCallback,
    useRegExp: boolean,
    accuracy: Accuracy
) {
    if (keywords.length || hasEverMarked) {
        hasEverMarked = true;
        const MarkJS = await getMarkJS();
        const marker = MarkJS.call(MarkJS, element);

        keywords.forEach(keyword => {
            let count = 0;
            let options = {
                element: SPAN_ELEMENT_NAME,
                className: createMarkId(),
                // Each element belonging to the same keyword should have the same identifier
                // This is needed for unmarking user highlights on keywords across elements (VSO20847)
                acrossElements: true,
                separateWordSearch: false,
                accuracy: accuracy,
                each: (matchedElement: HTMLElement) => {
                    if (!isEmptyElement(matchedElement)) {
                        eachCallback(keyword)(matchedElement, count);
                        count++;
                    }
                },
            };

            if (useRegExp) {
                marker.markRegExp(new RegExp(keyword), options);
            } else {
                marker.mark(keyword, options);
            }
        });

        marker.unmark({ className: UNMARK_ELEMENT_LABEL });
    }
}

function isEmptyElement(element: HTMLElement): boolean {
    let content = element.innerHTML.replace(/&nbsp;/gi, '').trim();
    if (!content) {
        // Elements whose content is blank (i.e. breaks, empty table elements,
        // or spans whose content just include whitespace) should not be highlighted
        // Add class name denoting should be removed later
        element.classList.add(UNMARK_ELEMENT_LABEL);
        return true;
    }

    return false;
}
